export default "__VITE_ASSET__BCdPRn0C__"